export default "__VITE_ASSET__DgceJt6F__"